import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgDesonideGlyph from './svgs/DesonideGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var desonideGlyph = (props => useIcon(SvgDesonideGlyph, null, props));

export { desonideGlyph as default };
